/**
 * Object.polyfill.assign(Object target, Mixed varArgs)
 *
 * Merges the two objects to make one
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
 */
 if (typeof Object.assign != 'function') {
  Object.assign = function(target, varArgs) { // .length of function is 2
    'use strict';
    if (target == null) { // TypeError if undefined or null
      throw new TypeError('Cannot convert undefined or null to object');
    }

    var to = Object(target);

    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];

      if (nextSource != null) { // Skip over if undefined or null
        for (var nextKey in nextSource) {
          // Avoid bugs when hasOwnProperty is shadowed
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

/**
 * Returns whether the current object contains any keys/is empty
 */
if (typeof Object.isEmpty != 'function') {
    Object.isEmpty = function(target) {
        if(target == null || target == undefined)
            return true;

        for(var key in target) {
            if(target.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
}

/**
 * Filters the current object by a custom method
 */
if (typeof Object.filter != 'function') {
    Object.filter = function( obj, predicate) {
        var result = {}, key;
        // ---------------^---- as noted by @CMS,
        //      always declare variables with the "var" keyword

        for (key in obj) {
            if (obj.hasOwnProperty(key) && !predicate(obj[key])) {
                result[key] = obj[key];
            }
        }

        return result;
    };
}



// WEBPACK FOOTER //
// ./src/api/prototypes/Object.js